import React, { useState } from "react";
import '../../CustomAssets/Css/Components/Navbar.css';
import { NavLink } from 'react-router-dom';
import { IoMenu } from "react-icons/io5";
import { Logo, Logo1 } from '../Image_exports/MainLogo.jsx';

export default function Navbar({ CallSidePanel }) {


  return (
    <>
      <header className="header-section header-sticky org_clr">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <nav className="navbar navbar-expand-xl nav-shadow">

                <NavLink to="/" className="d-flex align-items-center text-decoration-none">
                  <Logo1 clsNm="main_logo_size" />
                  {/* <span className="main_logo_text">LOANSMONEY</span> */}
                </NavLink>

                <div className="collapse navbar-collapse">
                  <div className="main-menu">

                    <ul id="menu-main-menu" className="navbar-nav mb-lg-0">
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2818 nav-item">
                        <NavLink to={"/"} title="Home" className="nav-item">Home</NavLink>
                      </li>


                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2818 nav-item">
                        <NavLink to={"/aboutUs"} title="About" className="nav-item">About</NavLink>
                      </li>

                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2818 nav-item">
                        <NavLink to={"/services"} title="Services" className="nav-item">Services</NavLink>
                      </li>

                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2818 nav-item">
                        <NavLink to={"/plans"} title="Plans" className="nav-item">Plans</NavLink>
                      </li>

                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2818 nav-item">
                        <NavLink to={"/careers"} title="Contact Us" className="nav-item">Career</NavLink>
                      </li>


                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2818 nav-item">
                        <NavLink to={"/contactUs"} title="Contact Us" className="nav-item">Contact Us</NavLink>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="nav-right d-none d-xl-flex">
                  <button onClick={() => window.location.href = "https://loansmoney.in/partnerPanel/"} className="btn_theme btn_clr">
                    Sign In
                  </button>
                </div>

                <div className='hamburger_menuIcon'>
                  <span onClick={() => CallSidePanel(true)}>< IoMenu /></span>
                </div>

              </nav>
            </div>
          </div>
        </div >
      </header >

    </>
  )
}
